import { AiOutlineHome } from "react-icons/ai";
import { FaRegNewspaper } from "react-icons/fa6";
import { MdOutlineLayers } from "react-icons/md";
import { SiStyledcomponents } from "react-icons/si";
import { HiIdentification } from "react-icons/hi";

export const SidebarMenu = [
  {
    name: "Home",
    icon: <AiOutlineHome className="text-xl" />,
    path: "",
    children: [],
  },
  {
    name: "About",
    icon: <HiIdentification />,
    path: "/about",
    children: [],
  },
  {
    name: "Content",
    icon: <FaRegNewspaper />,
    path: "/content",
    children: [
      {
        name: "Format",
        path: "content/format",
      },
      {
        name: "Grammar",
        path: "content/grammar",
      },
      {
        name: "Principles",
        path: "content/principles",
      },
    ],
  },
  {
    name: "Premise",
    path: "/premise",
    icon: <MdOutlineLayers className="text-xl" />,
    children: [
      {
        name: "Color",
        path: "premise/color",
      },
      {
        name: "Opacity",
        path: "premise/opacity",
      },
      {
        name: "Typography",
        path: "premise/typography",
      },
    ],
  },
  {
    name: "Component",
    path: "component",
    icon: <SiStyledcomponents className="text-xl" />,
    children: [
      {
        name: "Accordion",
        path: "component/accordion",
      },
      {
        name: "Breadcrumb",
        path: "component/breadcrumb",
      },
      {
        name: "Button",
        path: "component/button",
      },
      {
        name: "Card",
        path: "component/card",
      },
      {
        name: "Date Picker",
        path: "component/datepicker",
      },
      {
        name: "Input",
        path: "component/input",
      },
      {
        name: "Loading",
        path: "component/loading",
      },
      {
        name: "Modal",
        path: "component/modal",
      },
      {
        name: "Multiselect",
        path: "component/multiselect",
      },
      {
        name: "Notification",
        path: "component/notification",
      },
      {
        name: "Tooltip",
        path: "component/tooltip",
      },
    ],
  },
];
